const FetchStatus = {
  INITIAL: 'INITIAL',
  FETCHING: 'FETCHING',
  ERROR: 'ERROR',
  DONE: 'DONE',
}

export default FetchStatus